export class piDB {
    constructor(db) {
        this.ongoingQueries = new Map();
        this.loadIDB = () => {
            if (!this.DB_NAME || this.DB_VERSION < 0 || this.tables.length === 0) {
                return [];
            }
            let request = window.indexedDB.open(this.DB_NAME, this.DB_VERSION);
            request.onerror = event => {
                // Do something with request.errorCode!
                console.log('Error opening db', request.error, this);
            };
            //if version has incremented check for new tables and indexes
            request.onupgradeneeded = (event) => {
                const DB = event.target.result;
                console.log('UpgradingIDB', DB);
                for (let table of this.tables) {
                    let objectStore;
                    //create base objectStore for table
                    if (!DB.objectStoreNames.contains(table.tableName)) {
                        objectStore = DB.createObjectStore(table.tableName, {
                            keyPath: table.keyPath
                        });
                    }
                    else {
                        objectStore = event.target.transaction.objectStore(table.tableName);
                    }
                    //create lowercase index for keypath
                    if (!objectStore.indexNames.contains(table.keyPath + '_lower')) {
                        objectStore.createIndex(table.keyPath + '_lower', table.keyPath + '_lower', {
                            unique: true
                        });
                    }
                    //create lowercase index for indexes
                    for (let idx of table.indexes) {
                        const idxNameLower = idx.name + '_lower';
                        if (objectStore.indexNames.contains(idxNameLower)) {
                            console.log('Skipping existing index', idxNameLower);
                            continue;
                        }
                        objectStore.createIndex(idxNameLower, idxNameLower, {
                            unique: idx.isUnique
                        });
                    }
                }
            };
            request.onblocked = (event) => {
                console.log('BLOCKED', event);
            };
            //id success check if new data is available
            request.onsuccess = (event) => {
                const DB = event.target.result;
                console.log('Connected', DB);
                //this.stores = DB.objectStoreNames;
                DB.onversionchange = (event) => {
                    //TODO implement versionchange (fx if 2 tabs open with diff db version)
                    console.log('VERSION_CHANGE', event);
                    DB.close();
                    location.reload();
                };
                for (let table of this.tables) {
                    //TODO new data check | where should it be...
                    let data = '/rnd/indexedDB/data/' + table.tableName + '.json';
                    this.loadRecords(data, table, {
                        forceUpdate: false
                    }).then(n => console.log(`Loaded ${n} records for ${table.tableName}`));
                }
            };
        };
        this.DB_NAME = db.dbname;
        this.DB_VERSION = db.version;
        this.tables = db.tables;
        this.loadIDB();
    }
    async loadRecords(data, table, options) {
        return new Promise(async (resolve, reject) => {
            var _a;
            if (!data || !table)
                resolve(0);
            try {
                let json;
                if (typeof data === 'object') {
                    json = data;
                }
                else {
                    const lastUpdated = Number(localStorage.getItem('__idb__' + table.tableName));
                    let filerequest = await fetch(data, { method: 'HEAD' });
                    let lastModifiedHeader = [...filerequest.headers].find(header => header[0].toLowerCase() === 'last-modified');
                    let lastModified = lastModifiedHeader ? new Date(lastModifiedHeader[1]).getTime() : new Date().getTime();
                    const ONE_WEEK = 1000 * 60 * 60 * 24 * 7;
                    const FORCE_UDPATE = (_a = options === null || options === void 0 ? void 0 : options.forceUpdate) !== null && _a !== void 0 ? _a : false;
                    //Update data if file modified on disk, or data older than 1week
                    console.log('FileCheck', table.tableName, lastModified > lastUpdated, lastModified, lastUpdated, FORCE_UDPATE, (!FORCE_UDPATE && (lastModified <= lastUpdated || (new Date().getTime() - lastUpdated > ONE_WEEK))));
                    if (!FORCE_UDPATE && (lastModified <= lastUpdated || (new Date().getTime() - lastUpdated > ONE_WEEK))) {
                        console.log('Not updating ' + table.tableName);
                        resolve(0);
                    }
                    let request = await fetch(data); //data can be a file, or perhaps a url
                    json = await request.json();
                }
                if (json.length === 0)
                    resolve(0);
                let request_db = window.indexedDB.open(this.DB_NAME);
                request_db.onsuccess = (event) => {
                    const db = event.target.result;
                    let transaction = db.transaction([table.tableName], 'readwrite');
                    transaction.oncomplete = (event) => {
                        console.log("All done!");
                        console.timeEnd('insert-' + table.tableName);
                        localStorage.setItem('__idb__' + table.tableName, new Date().getTime().toString());
                    };
                    let n = 0;
                    console.time('insert-' + table.tableName);
                    let objectStore = transaction.objectStore(table.tableName);
                    //TODO, handle deletions when updating databse ...
                    for (const record of json) {
                        if (!record[table.keyPath])
                            continue;
                        record[table.keyPath + '_lower'] = record[table.keyPath].toLowerCase();
                        for (const idx of table.indexes) {
                            record[idx.name + '_lower'] = record[idx.name].toLowerCase();
                        }
                        n += 1;
                        if (n % 100000 === 0)
                            console.log('Record', record);
                        objectStore.put(record); //handle error on put
                    }
                    resolve(n);
                };
            }
            catch (e) {
            }
        });
    }
    getRecords(table, index, query, identifier) {
        return new Promise((resolve, reject) => {
            if (!query)
                resolve([]);
            window.indexedDB.open(this.DB_NAME).onsuccess = (event) => {
                var _a, _b;
                const DB = event.target.result;
                if (!identifier)
                    identifier = `${this.DB_NAME}-${this.DB_VERSION}-${table}`;
                identifier = '__' + identifier;
                //Abort previous transaction before beginning new one
                if (this.ongoingQueries.has(identifier)) {
                    console.log('AbortingTransaction', identifier);
                    console.timeEnd('query' + identifier);
                    try {
                        (_b = (_a = this.ongoingQueries.get(identifier)) === null || _a === void 0 ? void 0 : _a.transaction) === null || _b === void 0 ? void 0 : _b.abort();
                    }
                    catch (e) {
                        //
                    }
                }
                console.time('query' + identifier);
                //Run from current char to next char not inclusive, ensures everything that begins with query is returned
                let upperLimit = query.slice(0, query.length - 1) + String.fromCharCode(query.slice(-1).charCodeAt(0) + 1);
                const bounds = IDBKeyRange.bound(query, upperLimit, false, true);
                let getTransaction = index
                    ? DB.transaction([table]).objectStore(table).index(index).getAll(bounds)
                    : DB.transaction([table]).objectStore(table).getAll(bounds);
                this.ongoingQueries.set(identifier, getTransaction);
                getTransaction.onsuccess = (eventGetTransaction) => {
                    const result = getTransaction.result;
                    console.timeEnd('query' + identifier);
                    if (identifier)
                        this.ongoingQueries.delete(identifier);
                    resolve(result);
                };
            };
        });
    }
}
//# sourceMappingURL=piDB.js.map